// extracted by mini-css-extract-plugin
module.exports = {"contDestacatInformatiu":"informatiusDestacats_contDestacatInformatiu__OvN1q"};